import {
  getPassportTypeDictSelector,
  getLeaveTypeDictSelector,
  getSalaryTypeDictSelector,
  getRequestTypeDictSelector,
  getITReqItemsDictSelector,
  getAttendanceTypesDict,
  getCountriesDictSelector,
} from '@Store/selectors/dictionarySelector';
import { CountryDict, RequestTypes, TypeDict } from 'types';

import { RequestType } from '@Enum/index';
import { getReasonOptions } from '@Features/EmployeeSelfService/requests/ResignationRequests/store/selectors/resignationRequestSelector';
import { OptionNum } from '@Components/types/options';
import { useAppSelector } from '.';

interface ReturnedValue {
  findRequestTitle: (leaveTypeID: number) => string;
}

// eslint-disable-next-line
const mapperTypesDictionary: any = {
  Leave: getLeaveTypeDictSelector,
  Passport: getPassportTypeDictSelector,
  Salary: getSalaryTypeDictSelector,
  ITRequisition: getITReqItemsDictSelector,
  Material: getRequestTypeDictSelector,
  Attendance: getAttendanceTypesDict,
  AttendanceProfile: getAttendanceTypesDict, // Use the same att type dict for resolve issuew with useSelector (in common Att Profile do not have any dict)
  Resumption: getLeaveTypeDictSelector,
  Overseas: getCountriesDictSelector,
  Resignation: getReasonOptions,
  Purchase: getRequestTypeDictSelector,
  Tender: getRequestTypeDictSelector, // mock
  ESSTaskRequest: getLeaveTypeDictSelector, // mock
  MRTaskRequest: getRequestTypeDictSelector,
};

const useLeaveTypeTitleFinderById = (
  requestType: RequestTypes
): ReturnedValue => {
  const dictionaryTypes: TypeDict[] | CountryDict[] | OptionNum[] =
    useAppSelector(mapperTypesDictionary[requestType]);

  let findRequestTitle;

  switch (requestType) {
    case RequestType.OVERSEAS:
      findRequestTitle = (leaveTypeID: number): string =>
        (dictionaryTypes as CountryDict[]).find(
          (item) => item.id === leaveTypeID
        )?.countryName || '';
      break;
    case RequestType.RESIGNATION:
      findRequestTitle = (reason: number): string =>
        (dictionaryTypes as OptionNum[]).find((item) => item.value === reason)
          ?.label || '';
      break;
    default:
      findRequestTitle = (leaveTypeID: number): string =>
        (dictionaryTypes as TypeDict[]).find(
          (item) => item.codeNum === leaveTypeID
        )?.codeDesc || '';
  }

  return { findRequestTitle };
};

export default useLeaveTypeTitleFinderById;
